/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'
import { createServerRootRoute } from '@tanstack/react-start/server'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppLayoutRouteImport } from './routes/app/_layout'
import { Route as authLogoutRouteImport } from './routes/(auth)/logout'
import { Route as authLoginCallbackRouteImport } from './routes/(auth)/loginCallback'
import { Route as authLoginSsoRouteImport } from './routes/(auth)/login-sso'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as AppLayoutUsersRouteImport } from './routes/app/_layout/users'
import { Route as AppLayoutTasksRouteImport } from './routes/app/_layout/tasks'
import { Route as AppLayoutSettingsRouteImport } from './routes/app/_layout/settings'
import { Route as AppLayoutProfileRouteImport } from './routes/app/_layout/profile'
import { Route as AppLayoutPlanningRouteImport } from './routes/app/_layout/planning'
import { Route as AppLayoutOperationsRouteImport } from './routes/app/_layout/operations'
import { Route as AppLayoutFilesRouteImport } from './routes/app/_layout/files'
import { Route as AppLayoutAnalyticsRouteImport } from './routes/app/_layout/analytics'
import { Route as AppLayoutAnalyticsOverviewRouteImport } from './routes/app/_layout/analytics/overview'
import { Route as AppLayoutAnalyticsOperationsRouteImport } from './routes/app/_layout/analytics/operations'
import { ServerRoute as WebhookUserServerRouteImport } from './routes/webhook/user'
import { ServerRoute as WebhookSendPasswordEmailServerRouteImport } from './routes/webhook/send-password-email'
import { ServerRoute as WebhookNotificationServerRouteImport } from './routes/webhook/notification'

const AppRouteImport = createFileRoute('/app')()
const rootServerRouteImport = createServerRootRoute()

const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppLayoutRoute = AppLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => AppRoute,
} as any)
const authLogoutRoute = authLogoutRouteImport.update({
  id: '/(auth)/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const authLoginCallbackRoute = authLoginCallbackRouteImport.update({
  id: '/(auth)/loginCallback',
  path: '/loginCallback',
  getParentRoute: () => rootRouteImport,
} as any)
const authLoginSsoRoute = authLoginSsoRouteImport.update({
  id: '/(auth)/login-sso',
  path: '/login-sso',
  getParentRoute: () => rootRouteImport,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppLayoutUsersRoute = AppLayoutUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppLayoutTasksRoute = AppLayoutTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppLayoutSettingsRoute = AppLayoutSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppLayoutProfileRoute = AppLayoutProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppLayoutPlanningRoute = AppLayoutPlanningRouteImport.update({
  id: '/planning',
  path: '/planning',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppLayoutOperationsRoute = AppLayoutOperationsRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppLayoutFilesRoute = AppLayoutFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppLayoutAnalyticsRoute = AppLayoutAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppLayoutAnalyticsOverviewRoute =
  AppLayoutAnalyticsOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AppLayoutAnalyticsRoute,
  } as any)
const AppLayoutAnalyticsOperationsRoute =
  AppLayoutAnalyticsOperationsRouteImport.update({
    id: '/operations',
    path: '/operations',
    getParentRoute: () => AppLayoutAnalyticsRoute,
  } as any)
const WebhookUserServerRoute = WebhookUserServerRouteImport.update({
  id: '/webhook/user',
  path: '/webhook/user',
  getParentRoute: () => rootServerRouteImport,
} as any)
const WebhookSendPasswordEmailServerRoute =
  WebhookSendPasswordEmailServerRouteImport.update({
    id: '/webhook/send-password-email',
    path: '/webhook/send-password-email',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const WebhookNotificationServerRoute =
  WebhookNotificationServerRouteImport.update({
    id: '/webhook/notification',
    path: '/webhook/notification',
    getParentRoute: () => rootServerRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof authLoginRoute
  '/login-sso': typeof authLoginSsoRoute
  '/loginCallback': typeof authLoginCallbackRoute
  '/logout': typeof authLogoutRoute
  '/app': typeof AppLayoutRouteWithChildren
  '/app/': typeof AppIndexRoute
  '/app/analytics': typeof AppLayoutAnalyticsRouteWithChildren
  '/app/files': typeof AppLayoutFilesRoute
  '/app/operations': typeof AppLayoutOperationsRoute
  '/app/planning': typeof AppLayoutPlanningRoute
  '/app/profile': typeof AppLayoutProfileRoute
  '/app/settings': typeof AppLayoutSettingsRoute
  '/app/tasks': typeof AppLayoutTasksRoute
  '/app/users': typeof AppLayoutUsersRoute
  '/app/analytics/operations': typeof AppLayoutAnalyticsOperationsRoute
  '/app/analytics/overview': typeof AppLayoutAnalyticsOverviewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof authLoginRoute
  '/login-sso': typeof authLoginSsoRoute
  '/loginCallback': typeof authLoginCallbackRoute
  '/logout': typeof authLogoutRoute
  '/app': typeof AppIndexRoute
  '/app/analytics': typeof AppLayoutAnalyticsRouteWithChildren
  '/app/files': typeof AppLayoutFilesRoute
  '/app/operations': typeof AppLayoutOperationsRoute
  '/app/planning': typeof AppLayoutPlanningRoute
  '/app/profile': typeof AppLayoutProfileRoute
  '/app/settings': typeof AppLayoutSettingsRoute
  '/app/tasks': typeof AppLayoutTasksRoute
  '/app/users': typeof AppLayoutUsersRoute
  '/app/analytics/operations': typeof AppLayoutAnalyticsOperationsRoute
  '/app/analytics/overview': typeof AppLayoutAnalyticsOverviewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/login-sso': typeof authLoginSsoRoute
  '/(auth)/loginCallback': typeof authLoginCallbackRoute
  '/(auth)/logout': typeof authLogoutRoute
  '/app': typeof AppRouteWithChildren
  '/app/_layout': typeof AppLayoutRouteWithChildren
  '/app/': typeof AppIndexRoute
  '/app/_layout/analytics': typeof AppLayoutAnalyticsRouteWithChildren
  '/app/_layout/files': typeof AppLayoutFilesRoute
  '/app/_layout/operations': typeof AppLayoutOperationsRoute
  '/app/_layout/planning': typeof AppLayoutPlanningRoute
  '/app/_layout/profile': typeof AppLayoutProfileRoute
  '/app/_layout/settings': typeof AppLayoutSettingsRoute
  '/app/_layout/tasks': typeof AppLayoutTasksRoute
  '/app/_layout/users': typeof AppLayoutUsersRoute
  '/app/_layout/analytics/operations': typeof AppLayoutAnalyticsOperationsRoute
  '/app/_layout/analytics/overview': typeof AppLayoutAnalyticsOverviewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/login-sso'
    | '/loginCallback'
    | '/logout'
    | '/app'
    | '/app/'
    | '/app/analytics'
    | '/app/files'
    | '/app/operations'
    | '/app/planning'
    | '/app/profile'
    | '/app/settings'
    | '/app/tasks'
    | '/app/users'
    | '/app/analytics/operations'
    | '/app/analytics/overview'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/login-sso'
    | '/loginCallback'
    | '/logout'
    | '/app'
    | '/app/analytics'
    | '/app/files'
    | '/app/operations'
    | '/app/planning'
    | '/app/profile'
    | '/app/settings'
    | '/app/tasks'
    | '/app/users'
    | '/app/analytics/operations'
    | '/app/analytics/overview'
  id:
    | '__root__'
    | '/'
    | '/(auth)/login'
    | '/(auth)/login-sso'
    | '/(auth)/loginCallback'
    | '/(auth)/logout'
    | '/app'
    | '/app/_layout'
    | '/app/'
    | '/app/_layout/analytics'
    | '/app/_layout/files'
    | '/app/_layout/operations'
    | '/app/_layout/planning'
    | '/app/_layout/profile'
    | '/app/_layout/settings'
    | '/app/_layout/tasks'
    | '/app/_layout/users'
    | '/app/_layout/analytics/operations'
    | '/app/_layout/analytics/overview'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  authLoginRoute: typeof authLoginRoute
  authLoginSsoRoute: typeof authLoginSsoRoute
  authLoginCallbackRoute: typeof authLoginCallbackRoute
  authLogoutRoute: typeof authLogoutRoute
  AppRoute: typeof AppRouteWithChildren
}
export interface FileServerRoutesByFullPath {
  '/webhook/notification': typeof WebhookNotificationServerRoute
  '/webhook/send-password-email': typeof WebhookSendPasswordEmailServerRoute
  '/webhook/user': typeof WebhookUserServerRoute
}
export interface FileServerRoutesByTo {
  '/webhook/notification': typeof WebhookNotificationServerRoute
  '/webhook/send-password-email': typeof WebhookSendPasswordEmailServerRoute
  '/webhook/user': typeof WebhookUserServerRoute
}
export interface FileServerRoutesById {
  __root__: typeof rootServerRouteImport
  '/webhook/notification': typeof WebhookNotificationServerRoute
  '/webhook/send-password-email': typeof WebhookSendPasswordEmailServerRoute
  '/webhook/user': typeof WebhookUserServerRoute
}
export interface FileServerRouteTypes {
  fileServerRoutesByFullPath: FileServerRoutesByFullPath
  fullPaths:
    | '/webhook/notification'
    | '/webhook/send-password-email'
    | '/webhook/user'
  fileServerRoutesByTo: FileServerRoutesByTo
  to: '/webhook/notification' | '/webhook/send-password-email' | '/webhook/user'
  id:
    | '__root__'
    | '/webhook/notification'
    | '/webhook/send-password-email'
    | '/webhook/user'
  fileServerRoutesById: FileServerRoutesById
}
export interface RootServerRouteChildren {
  WebhookNotificationServerRoute: typeof WebhookNotificationServerRoute
  WebhookSendPasswordEmailServerRoute: typeof WebhookSendPasswordEmailServerRoute
  WebhookUserServerRoute: typeof WebhookUserServerRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/_layout': {
      id: '/app/_layout'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppLayoutRouteImport
      parentRoute: typeof AppRoute
    }
    '/(auth)/logout': {
      id: '/(auth)/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof authLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/loginCallback': {
      id: '/(auth)/loginCallback'
      path: '/loginCallback'
      fullPath: '/loginCallback'
      preLoaderRoute: typeof authLoginCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/login-sso': {
      id: '/(auth)/login-sso'
      path: '/login-sso'
      fullPath: '/login-sso'
      preLoaderRoute: typeof authLoginSsoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/_layout/users': {
      id: '/app/_layout/users'
      path: '/users'
      fullPath: '/app/users'
      preLoaderRoute: typeof AppLayoutUsersRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/app/_layout/tasks': {
      id: '/app/_layout/tasks'
      path: '/tasks'
      fullPath: '/app/tasks'
      preLoaderRoute: typeof AppLayoutTasksRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/app/_layout/settings': {
      id: '/app/_layout/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppLayoutSettingsRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/app/_layout/profile': {
      id: '/app/_layout/profile'
      path: '/profile'
      fullPath: '/app/profile'
      preLoaderRoute: typeof AppLayoutProfileRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/app/_layout/planning': {
      id: '/app/_layout/planning'
      path: '/planning'
      fullPath: '/app/planning'
      preLoaderRoute: typeof AppLayoutPlanningRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/app/_layout/operations': {
      id: '/app/_layout/operations'
      path: '/operations'
      fullPath: '/app/operations'
      preLoaderRoute: typeof AppLayoutOperationsRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/app/_layout/files': {
      id: '/app/_layout/files'
      path: '/files'
      fullPath: '/app/files'
      preLoaderRoute: typeof AppLayoutFilesRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/app/_layout/analytics': {
      id: '/app/_layout/analytics'
      path: '/analytics'
      fullPath: '/app/analytics'
      preLoaderRoute: typeof AppLayoutAnalyticsRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/app/_layout/analytics/overview': {
      id: '/app/_layout/analytics/overview'
      path: '/overview'
      fullPath: '/app/analytics/overview'
      preLoaderRoute: typeof AppLayoutAnalyticsOverviewRouteImport
      parentRoute: typeof AppLayoutAnalyticsRoute
    }
    '/app/_layout/analytics/operations': {
      id: '/app/_layout/analytics/operations'
      path: '/operations'
      fullPath: '/app/analytics/operations'
      preLoaderRoute: typeof AppLayoutAnalyticsOperationsRouteImport
      parentRoute: typeof AppLayoutAnalyticsRoute
    }
  }
}
declare module '@tanstack/react-start/server' {
  interface ServerFileRoutesByPath {
    '/webhook/user': {
      id: '/webhook/user'
      path: '/webhook/user'
      fullPath: '/webhook/user'
      preLoaderRoute: typeof WebhookUserServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/webhook/send-password-email': {
      id: '/webhook/send-password-email'
      path: '/webhook/send-password-email'
      fullPath: '/webhook/send-password-email'
      preLoaderRoute: typeof WebhookSendPasswordEmailServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/webhook/notification': {
      id: '/webhook/notification'
      path: '/webhook/notification'
      fullPath: '/webhook/notification'
      preLoaderRoute: typeof WebhookNotificationServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
  }
}

interface AppLayoutAnalyticsRouteChildren {
  AppLayoutAnalyticsOperationsRoute: typeof AppLayoutAnalyticsOperationsRoute
  AppLayoutAnalyticsOverviewRoute: typeof AppLayoutAnalyticsOverviewRoute
}

const AppLayoutAnalyticsRouteChildren: AppLayoutAnalyticsRouteChildren = {
  AppLayoutAnalyticsOperationsRoute: AppLayoutAnalyticsOperationsRoute,
  AppLayoutAnalyticsOverviewRoute: AppLayoutAnalyticsOverviewRoute,
}

const AppLayoutAnalyticsRouteWithChildren =
  AppLayoutAnalyticsRoute._addFileChildren(AppLayoutAnalyticsRouteChildren)

interface AppLayoutRouteChildren {
  AppLayoutAnalyticsRoute: typeof AppLayoutAnalyticsRouteWithChildren
  AppLayoutFilesRoute: typeof AppLayoutFilesRoute
  AppLayoutOperationsRoute: typeof AppLayoutOperationsRoute
  AppLayoutPlanningRoute: typeof AppLayoutPlanningRoute
  AppLayoutProfileRoute: typeof AppLayoutProfileRoute
  AppLayoutSettingsRoute: typeof AppLayoutSettingsRoute
  AppLayoutTasksRoute: typeof AppLayoutTasksRoute
  AppLayoutUsersRoute: typeof AppLayoutUsersRoute
}

const AppLayoutRouteChildren: AppLayoutRouteChildren = {
  AppLayoutAnalyticsRoute: AppLayoutAnalyticsRouteWithChildren,
  AppLayoutFilesRoute: AppLayoutFilesRoute,
  AppLayoutOperationsRoute: AppLayoutOperationsRoute,
  AppLayoutPlanningRoute: AppLayoutPlanningRoute,
  AppLayoutProfileRoute: AppLayoutProfileRoute,
  AppLayoutSettingsRoute: AppLayoutSettingsRoute,
  AppLayoutTasksRoute: AppLayoutTasksRoute,
  AppLayoutUsersRoute: AppLayoutUsersRoute,
}

const AppLayoutRouteWithChildren = AppLayoutRoute._addFileChildren(
  AppLayoutRouteChildren,
)

interface AppRouteChildren {
  AppLayoutRoute: typeof AppLayoutRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppLayoutRoute: AppLayoutRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  authLoginRoute: authLoginRoute,
  authLoginSsoRoute: authLoginSsoRoute,
  authLoginCallbackRoute: authLoginCallbackRoute,
  authLogoutRoute: authLogoutRoute,
  AppRoute: AppRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
const rootServerRouteChildren: RootServerRouteChildren = {
  WebhookNotificationServerRoute: WebhookNotificationServerRoute,
  WebhookSendPasswordEmailServerRoute: WebhookSendPasswordEmailServerRoute,
  WebhookUserServerRoute: WebhookUserServerRoute,
}
export const serverRouteTree = rootServerRouteImport
  ._addFileChildren(rootServerRouteChildren)
  ._addFileTypes<FileServerRouteTypes>()
